import React from "react";
import { createRoot } from "react-dom/client";
import App2 from "./app.js/App2.js";
import App1 from "./app.js/App1.js";
import App3 from "./app.js/App3.js";
import App4 from "./app.js/App4.js";
import App5 from "./app.js/App5.js";
import App6 from "./app.js/App6.js";
/*import App7 from "./app.js/App7.js";
import App8 from "./app.js/App8.js";
import App9 from "./app.js/App9.js";
import App10 from "./app.js/App10.js";
import App11 from "./app.js/App11.js";
import App12 from "./app.js/App12.js";
import App13 from "./app.js/App13.js";
*/
import * as serviceWorker from "./serviceWorker";




const domNode2 = document.getElementById("2")
const due = createRoot(domNode2);
due.render(<App2 />);

const domNode1 = document.getElementById("1")
const uno = createRoot(domNode1);
uno.render(<App1 />);

const domNode3 = document.getElementById("3")
const tre = createRoot(domNode3);
tre.render(<App3 />);

const domNode4 = document.getElementById("4")
const quattro = createRoot(domNode4);
quattro.render(<App4 />);

const domNode5 = document.getElementById("5")
const cinque = createRoot(domNode5);
cinque.render(<App5 />);

const domNode6 = document.getElementById("6")
const sei = createRoot(domNode6);
sei.render(<App6 />);
/*
const domNode7 = document.getElementById("7")
const sette = createRoot(domNode7);
sette.render(<App7 />);

const domNode8 = document.getElementById("8")
const otto = createRoot(domNode8);
otto.render(<App8 />);

const domNode9 = document.getElementById("9")
const nove = createRoot(domNode9);
nove.render(<App9 />);

const domNode10 = document.getElementById("10")
const dieci = createRoot(domNode10);
dieci.render(<App10 />);

const domNode11 = document.getElementById("11")
const undici = createRoot(domNode11);
undici.render(<App11 />);

const domNode12 = document.getElementById("12")
const dodici = createRoot(domNode12);
dodici.render(<App12 />);

const domNode13 = document.getElementById("13")
const tredici = createRoot(domNode13);
tredici.render(<App13 />);
*/
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
